module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("Introduction")])])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“In grandness of conception and in the power with which a mass of material is subordinated to great ideas no writing in either Testament, dealing with a historical theme, is to be compared with Matthew. In this respect the present writer would be at a loss to find its equal also in the other literature of antiquity.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "ft1"
    }
  }, [_vm._v("1")]), _vm._v(" In these words a great scholar of an earlier day brought out something of the majesty of our first Gospel."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "ft2"
    }
  }, [_vm._v("2")])]), _vm._v(" We should bear this in mind when we recall how much this Gospel has suffered in modern discussions in comparison with the others. Mark is usually seen as the earliest of the four and as having a freshness about it that demands attention if we are looking for accurate information about Jesus. Luke is much fuller, and the beauty of his writing is so impressive that E. Renan called it “the most beautiful book that there is.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "ft3"
    }
  }, [_vm._v("3")])]), _vm._v(" John is very different from the other three and more theological. The result is that in modern times Matthew has often been slighted. It is good that such views are becoming outmoded."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "ft4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To disparage Matthew is a great mistake. Nobody should minimize the importance of the Gospel that contains the infancy stories, the Sermon on the Mount, and a rich collection of parables (many of which we find in this Gospel only), to name but a few of its contents. All four Gospels emphasize the passion narratives (giving rise to the view that they are all passion narratives with extensive introductions). But each has its own way of doing this, and while Matthew is usually held to rely heavily on Mark, his Gospel includes matter not found elsewhere (e.g., Jesus’ threefold prayer in Gethsemane, Jesus’ confidence that he could call on more than twelve legions of angels, and the suicide of Judas). This Evangelist makes it clear that the death of Jesus was in fulfilment of the plan of God; "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("sometimes he brings out its meaning explicitly, as when he says that Jesus came to give his life “a ransom for many” (20:28) or when he reports that Jesus spoke of the wine at the Last Supper as “my blood of the covenant, which is poured out for many for the forgiveness of sins” (26:28).")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("We should not overlook the fact that throughout most of the centuries of the Christian church this Gospel has been held to be the most important we have. In the ancient MSS it is the first of the four, and in common use it was clearly held to be the most important."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "ft5"
    }
  }, [_vm._v("5")]), _vm._v(" R. T. France writes, “it is a fact that mainstream Christianity was, from the early second century on, to a great extent Matthean Christianity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "ft6"
    }
  }, [_vm._v("6")])]), _vm._v(" We must not read back our prejudices into the early church; while few interpreters these days would endorse the verdict of the early church on the importance of this Gospel, we should not minimize the force of the considerations that produced that verdict."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "ft7"
    }
  }, [_vm._v("7")])]), _vm._v(" The contribution our first Gospel has made to the church throughout the centuries must not be overlooked nor minimized. And it still has much to say to the church today.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_c('strong', [_vm._v("I. DISTINCTIVE CHARACTERISTICS")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Matthew shares many features with the other Gospels, but some of them are especially characteristic of the first Gospel.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_c('em', [_c('strong', [_vm._v("A. Jewishness")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The writer seems concerned throughout to show that Christianity is the true continuation of the Old Testament — the true Judaism, if we may put it that way. He was clearly a knowledgeable Jew, well acquainted with the kind of teaching we find in the Mishnah and the Talmud, and some would "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("say not averse to the use of Midrash. He does not find it necessary to explain Jewish customs (compare 15:1-9 with Mark 7:1-13). He begins his genealogy with Abraham, the great ancestor of the Jewish race (1:1-2). He alone tells us that Jesus was sent to “the lost sheep of the house of Israel” (15:24; cf. 10:5-6). He writes of matters that would interest Jews, such as the Sabbath (12:1-14) and the temple tax (17:24-27)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "ft8"
    }
  }, [_vm._v("8")]), _vm._v(" Not all his comments, of course, are favorable to the Jews. There are some strong criticisms, notably in chapter 23, and we should notice his use of expressions like “their” scribes (7:29) and “their” synagogues (9:35), which distance the author from official Judaism."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "ft9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But most of all he was a genuine follower of Jesus, a convinced Jewish Christian. A striking example of his Jewishness is his emphasis on the fulfilment of prophecy. He has a formula, “that it might be fulfilled which was spoken by the Lord through the prophet —,” which we find as early as 1:22 and which recurs throughout the Gospel. From another angle, the United Bible Societies’ "), _c('em', [_vm._v("The Greek New Testament")]), _vm._v(" (3rd edn.) lists 61 quotations from the Old Testament in this Gospel compared with 31 in Mark, 26 in Luke, and 16 in John. Clearly the writer has a special interest in what the Old Testament Scripture says and the way it applies to Jesus. And it is not only the number of quotations that is important; it is the way they are used. Running throughout this Gospel is the thought that God is working his purpose out and that one way in which that purpose is to be discerned is the manner in which what God has inspired his prophets to say can be seen to have been fulfilled in the life and teaching of Jesus. And this Gospel ends with the great commission to make disciples from all the nations (28:16-20). Matthew has a Jewish background and he is deeply interested in Jews, but he is also interested in the relevance of Jesus for all the nations.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('em', [_c('strong', [_vm._v("B. Fulfilment in Christianity")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As we have indicated, the idea that what God was promising in the Old Testament scriptures is fulfilled in Christianity runs throughout this Gospel. This is to be seen in the many references to the fulfilment of prophecy, but, as Albright and Mann point out, “It was of the essence of the Gospel — supremely exemplified in Matthew and in Paul’s teaching — that all Israel’s experience had been gathered up, fulfilled, in Jesus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "ft10"
    }
  }, [_vm._v("10")])]), _vm._v(" We find it, for example, in the theme of kingship that features so prominently in this book. Jesus is seen as the Messiah (Matthew has the term "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Christ” 17 times, whereas Mark, whom he follows so closely, has it 7 times, and Luke 12 times; John, however, uses it most,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "ft11"
    }
  }, [_vm._v("11")]), _vm._v(" with 19 references). Matthew refers to Jesus as “the Son of David” 8 times (with another use of the term for Joseph [1:20]), an expression with overtones of royalty. This is brought out especially in a passage where Matthew emphasizes that Jesus is greater than David (22:41-45). He also refers to “the kingdom of heaven” 32 times, “the kingdom of God” 5 times, “the kingdom” 6 times, and “the kingdom of the Son of man” 3 times. But however it is expressed, the thought is that the divine kingdom has drawn near in the person of Jesus. It is another way of bringing out the fulfilment of the divine purpose, and it is a Jewish way of doing this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition, it is a way of emphasizing that the blessing of God that the Jews had looked for had now passed to the followers of Jesus. The Jews had not recognized the divine visitation when the Son of God came among them: “Many will come from the East and the West and will recline with Abraham and Isaac and Jacob in the kingdom of heaven” (8:11). With this we should take the many passages that speak of those who will or who will not enter the kingdom. There can be no doubt that these point to a Jewish way of thinking, but no doubt either that this Evangelist looks for them to be fulfilled in the followers of Jesus, not the Jewish nation.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_c('em', [_c('strong', [_vm._v("C. Ecclesiastical Interest")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By the time this Gospel was written the followers of Jesus were clearly distinct from the Jews (and not merely a group among the Jews as they had been in Jesus’ lifetime). Matthew is interested in them as a separate group, and it may be significant that he is the only one of our Evangelists to use the word “church” (16:18; 18:17). This can be exaggerated, and not too much should be built on the use of this particular word. But throughout the Gospel there is clearly an interest in the church as an organization. Its relationship to Jesus Christ is brought out in the incident in which Jesus spoke of building his church on Peter’s confession of his messiahship and the fact of its continuing existence in the passage in which Jesus tells his followers what to do when a brother offends and when he speaks of the power of binding and loosing (18:15-18). Matthew is very interested in Peter, and he has this apostle appear frequently in his narrative (even if it may be going a trifle too far to say, “if he had named his own book he might well have called it ‘The Good News According to Peter’”)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "ft12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps we should notice here Kilpatrick’s view that this Gospel is to be understood as a lectionary. He argues that the church would have "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("taken over the synagogal custom of the regular reading of Scripture, that Mark had been used in Christian services of worship, and that Matthew was written “as a kind of revised gospel book, conveniently incorporating into one volume the three documents Mark, Q, and M.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "ft13"
    }
  }, [_vm._v("13")]), _vm._v(" He holds that Matthew “was intended primarily to serve a liturgical purpose,” and he concludes his book with “The revision, if so we may describe it, was carried out so successfully that the Gospel, itself the most used of the four, has had no successors.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "ft14"
    }
  }, [_vm._v("14")])]), _vm._v(" The case is argued with learning and skill, but few have been persuaded. There are some grievous weaknesses. For example, Kilpatrick assumes far too easily that we know what was done in first-century synagogues. We should not assume that the church was taking over a well-known custom of the Jews, for we at any rate do not know what the Jews did by way of lectionary, if indeed they had a lectionary."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "ft15"
    }
  }, [_vm._v("15")])]), _vm._v(" And he ignores the New Testament indications that there was a strong charismatic element in early Christian worship. It is hard to fit a lectionary into the worship of which we read in 1 Corinthians (where it was not even known for certain who would preach, 1 Cor. 14:30). That this Gospel came to be used in church services is clear enough. That it was written to be used as a lectionary is not and is highly unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Krister Stendahl refers to Kilpatrick’s work and proceeds to sum up his own notable contribution to Matthean studies in this way: “We have elsewhere suggested a somewhat broader and yet more specific interpretation of the nature of Mt. by calling it a handbook for teaching and administration within the church, and we have compared its form with the Manual of Discipline from Qumrân.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "ft16"
    }
  }, [_vm._v("16")])]), _vm._v(" Stendahl stresses Matthew’s use of the Old Testament and speaks of a “school” with its own methods of interpretation. Not many scholars today accept his entire theory, but the comparison of Matthew to the Manual of Discipline is often accepted.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('em', [_c('strong', [_vm._v("D. Anti-Pharisaism")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Matthew also has a strong polemic against the Pharisees. These men formed a highly regarded sect among the Jews and were insistent that the traditions that came from the great ones of the past must be adhered to. They could not recognize the hand of God in what Jesus was doing, but opposed him at every turn. Matthew reports Jesus’ criticisms of the "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Pharisees as well as the attempts of these Jewish leaders to defeat the purposes of God he discerned in what Jesus taught and did.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_c('em', [_c('strong', [_vm._v("E. The Gentiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Matthew is interested in the way Gentiles were drawn in to follow Jesus. We do not find here the universalism of Paul or of Luke, but there is an insistence that Gentiles have their place in the divine scheme of things, and specifically in receiving the teaching and the help of Jesus. Thus Matthew reports the coming of the Magi to see the infant Jesus, he centers much of what he has to say on “Galilee of the Gentiles,” and he recounts stories like that of the healing of the centurion’s slave and of the daughter of the Canaanite woman.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_c('em', [_c('strong', [_vm._v("F. Teaching")])])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Matthew has a great interest in the teaching of Jesus,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "ft17"
    }
  }, [_vm._v("17")]), _vm._v(" and he expresses what he says very clearly."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "ft18"
    }
  }, [_vm._v("18")])]), _vm._v(" Thus the Sermon on the Mount is one of five great discourse sections, many parables are recorded, and from time to time there are statements that Jesus taught, without his teaching being expressly included in the Gospel. It is plain that Matthew valued the teaching of Jesus and made a point of passing a good deal of it on to his readers. He was also, it would seem, both a good teacher himself and a man with a great interest in the teachers in the church. There is little doubt that he wrote in such a way as to be of help to them (cf. Filson, “His immediate aim is to provide the Church’s teachers with a basic tool for their work”)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "ft19"
    }
  }, [_vm._v("19")])]), _vm._v(" Writing in a day when the possession of books was not common, he puts a good deal of teaching in a form easily memorized."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "ft20"
    }
  }, [_vm._v("20")])]), _vm._v(" He also arranges things in threes (three messages to Joseph, three denials of Peter), sevens (seven parables in ch. 13, seven woes in ch. 23), and other numerical groups that could be readily memorized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Matthew has a great gift for economy of words; where he shares a narrative with Mark he is almost always shorter. Thus France points out that to tell the story of the woman with a haemorrhage Mark takes 154 words and Luke 114, but Matthew uses only 48 words. “Yet Matthew’s bare account contains all the essential elements: the length of her illness, "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("her conviction that a mere touch of his garment would suffice, Jesus’ declaration, ‘Take heart, daughter, your faith has made you well’, and the fact of her instant healing.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "ft21"
    }
  }, [_vm._v("21")]), _vm._v(" But where he has additional information that he sees as important he can be longer than the others, as when he adds the words about Jesus being sent only to the lost sheep of the house of Israel to the story of the Canaanite woman (15:24).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Matthew has five considerable sections of teaching (chs. 5-7, 10, 13, 1 8, 23-25) — a fact that B. W. Bacon made the basis of a view that attracted a good deal of support, namely, that Matthew is replacing the five books of Moses with five books of the messianic Torah."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "ft22"
    }
  }, [_vm._v("22")])]), _vm._v(" Sometimes this notion is linked with suggestions of a New Moses or a New Exodus, but this does not seem to be what Matthew is driving at. W. D. Davies has examined Bacon’s view and concluded that Matthew’s “fivefold structure cannot certainly be held to have any theological significance, that is, it does not necessarily point to a deliberate interpretation of the Gospel in terms of a new Pentateuch, as, in its totality, a counterpart to the five books of Moses.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "ft23"
    }
  }, [_vm._v("23")])]), _vm._v(" Anyone who works with this Gospel must come to some conclusion about the sections into which it may be divided, but the difficulty in doing this is brought out by the fact that Filson comes up with three different outlines, each based on a way of looking at the Gospel as a whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "ft24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We should also bear in mind that seeing Jesus’ teaching merely in five discourses may be a trifle too confident. Furthermore, it involves lumping together chapters 23-25, whereas most students regard chapter 23 as a discourse distinct from chapters 24 and 25. H. B. Green also draws attention to the importance of chapter 11 and speaks of seven discourses."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "ft25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The resemblance to the Pentateuch has to be read into this Gospel; it is not the most natural way of understanding it.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-7"
    }
  }, [_c('em', [_c('strong', [_vm._v("G. The Kingdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An important feature of Matthew’s Gospel is his emphasis on God’s kingdom. As we noted earlier, he uses the expression “the kingdom of heaven” most frequently (32 times), though he also has the expression favored in the other Gospels, “the kingdom of God” (5 times), as well as “the kingdom” (5 times), and once also (in prayer) “your kingdom.” He uses expressions like “the kingdom of their Father” and “the kingdom of my Father,” and he refers to the kingdom of the “Son of man” (13:41, etc.). Ten times he introduces parables with “The kingdom of heaven is like —.” Sometimes the kingdom is clearly future (25:31), but sometimes it is thought of as coming in the person of Jesus (4:17; 12:28). For Matthew it is important that God is sovereign over all and that his rule will one day be brought to a glorious consummation. The present or the future aspect of the kingdom underlies a great deal of what is written in this Gospel.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Kingsbury draws attention to the importance of the expression “the gospel of the kingdom” (4:23; 9:35, etc.) and regards it as Matthew’s own designation of “the contents of his work … an expression that enables him to summarize in the same terms both the pre-Easter message of Jesus and the post-Easter message of his church.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "ft26"
    }
  }, [_vm._v("26")]), _vm._v(" This may be going too far; after all, Matthew does head his work “The book of the story of Jesus Christ” (1:1). But it does draw attention to the importance of the kingdom for Matthew.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_c('strong', [_vm._v("II. DATE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The testimony of antiquity is unanimous that the author of this Gospel was Matthew the apostle and that this was the first Gospel to be written. If this is accepted, the Gospel will have been written quite early. After examining the evidence from the patristics, France concludes: “Altogether, then, the patristic evidence seems unanimous that Matthew was written not later than the early sixties.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "ft27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But modern scholarship finds this conclusion more than a little difficult. It is generally held that this Gospel shows evidence of dependence on Mark (the passages common to the two Gospels are such that it is highly improbable that Mark used Matthew). Since Mark is thought to have been written not before about A.D. 65, this means that Matthew would "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("be dated at the earliest in the 70s. This evidence would be stronger if Mark could be dated with certainty."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "ft28"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many scholars find evidence for a somewhat late date in the use of expressions like “until now,” “until today” (11:12; 27:8; 28:15). But it is fairly countered that such expressions might well be used of something that happened twenty or thirty years ago, which would still enable us to date the Gospel in the 50s or 60s. Again, Matthew has a number of references to the destruction of Jerusalem, from which it has been concluded that he wrote after that city had been overthrown. Similarly it is suggested that the reference in the parable to the king who sent his armies and burned up the city refers to the destruction of Jerusalem (22:7)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "ft29"
    }
  }, [_vm._v("29")])]), _vm._v(" But those who speak so confidently of this verse as referring to the fall of Jerusalem usually overlook the fact that the city was not in fact burned. Josephus tells us that the temple was burned (War 6.249-50), but he does not speak of the city as destroyed by fire."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "ft30"
    }
  }, [_vm._v("30")])]), _vm._v(" Some expressions in Jesus’ eschatological discourse are also said to reflect the overthrow of that city (e.g., 24:15-19). But all these references are general and point to the kind of thing that was common when armies captured cities, so that they scarcely amount to more than predictions that Jerusalem would be destroyed. And with the continuing strife between Jewish hotheads and the Romans, together with the well-known Roman attitude toward rebellion, to forecast that Jerusalem would be destroyed, and more specifically that it would be burned, would require no supernatural insight. We should not overlook Jesus’ “immediately” (24:29); it is curious that Matthew should be reporting without qualification that Jesus said the end of the age would follow “immediately” after the destruction of Jerusalem if he is writing after the city has fallen."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "ft31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The references to the church (16:18-19; 18:17-18) are adduced as pointing to a development that must have taken time to bring about. To "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("which it is countered that there is no indication of any significant development of church order; the organization presupposed in these passages is of the simplest sort and does not require anything more complex than is revealed in the Pauline letters. Unless we read later ideas into them, the references do not demand anything beyond the primitive Palestinian communities from what we know of them. So with the allegation that the apostles are highly reverenced and that the writer softens or omits derogatory references. Paul insisted on the dignity of an apostle at a date earlier than any usually adduced for any of the Gospels. It has been suggested that the appearance of false prophets (7:15, 22) indicates a late date, but once again Paul shows that false prophets made their appearance quite early.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With this we should take the anti-Jewish tone of some parts of the Gospel (cf. 8:10-12; 21:43; 23, etc.). This is said to be the kind of thing we might expect in the period from A.D. 85 on, when the Jewish authorities were excluding Christians from their synagogues. Not as much is known about this process of exclusion and its precise dating as is sometimes claimed, but in any case the situation reflected in this Gospel is not that of a definite break. Rather, it is the sort of thing we would expect when different kinds of Jews were arguing with one another, with the messianic Jews still hoping that other Jews would come to see things their way. Acts provides evidence that from quite early days orthodox Jews took action against Christians (Acts 4:1-3, 17-18; 5:40; 13:50, etc.).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Some aspects of this Gospel do point to an early date. Thus it was clearly the favorite Gospel in the early church, but it lacked the prestige of a center like Rome or Ephesus and there was no suggestion of a Peter (as in the case of Mark) or other outstanding figure behind it; Matthew was always a comparatively unimportant apostle. Again, the Judaic elements in the Gospel would have discredited it if it had appeared when the separation between church and synagogue had progressed beyond the early stages. We should not miss the point that the references to the destruction of Jerusalem are all forward looking and therefore should be taken to point to a time before it occurred. Some interpreters point out that there is no reference to the Pauline epistles, whereas it might be expected that a late writing would show knowledge of, for example, the list of resurrection appearances (1 Cor. 15:5-8). It has further been pointed out that Matthew’s story of the temple tax (17:24-27) implies that it is proper for Jewish followers of Jesus to pay that tax. This would apply before A.D. 70, for during that period the tax went to maintain the temple at Jerusalem. But after that date the Romans insisted that, while the tax must be paid by all Jews, it was to be used for the support of idol temples. It is not easy to see why the story should be included without qualification if it was written after A.D. 70. Matthew refers to the Sadducees 7 times (as many as all the other books of the New Testament put together; Mark and Luke have the term once each). This reflects the time before A.D. 70; after ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("that date we hear little of the Sadducees. Jesus’ warning against flight in winter or on a Sabbath (24:20) reads strangely if the flight had already taken place. Gundry gives further indication of an early date when he points out that this Gospel evidences in its quotations a “working upon the Hebrew text of the OT,” for after the church broke from the synagogue “access to Hebrew scrolls must have been difficult.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "ft32"
    }
  }, [_vm._v("32")]), _vm._v(" J. A. T. Robinson argues that there was probably a “proto-Matthew” (reflected in some parts of the Didache) and that this was later enlarged. He says, “The final stages of the three synoptic gospels as we have them would then have occupied the latter 50s or early 60s.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "ft33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From all this it is clear that there is little hard evidence to determine the date of this Gospel. Most modern scholars date it somewhere in the period from the 70s to the 90s, but there is good reason for seeing it as appearing before A.D. 70, perhaps the late 50s or early 60s. We can scarcely be more definite."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "ft34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_c('strong', [_vm._v("III. PLACE OF ORIGIN")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Very little can be said about the provenance of this writing. The indications that it was written for a Jewish Christian community might point to a place in Palestine, and this is supported by the tradition recorded by Papias that it was written for Hebrews. This would apply to Palestine, but also to such a center as Antioch in Syria."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "ft35"
    }
  }, [_vm._v("35")])]), _vm._v(" That city had a sizeable number of Jews in it, and we know from Acts that quite early there was a Christian church there, a church that was very active, for example, in sending out missionaries like Paul and Barnabas (Acts 13:1-3). It is not unlikely that it was in this center that our first Gospel was written. This view is supported by the fact that Ignatius, bishop of Antioch in the early second century, almost certainly refers to this Gospel when he speaks of Christ as having been baptized by John, “that all righteousness might be fulfilled by him” ("), _c('em', [_vm._v("Smyrn.")]), _vm._v(" 1.1; this appears to be a quotation from Matt. 3:15). G. D. Kilpatrick has difficulties with Antioch and prefers one of the Phoenician cities, perhaps Tyre or Sidon."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "ft36"
    }
  }, [_vm._v("36")])]), _vm._v(" Another suggestion is that some place in Palestine itself was the origin, perhaps Caesarea."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "ft37"
    }
  }, [_vm._v("37")])]), _vm._v(" A few interpreters have thought "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("that Alexandria is likely the place where this Gospel came into being."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "ft38"
    }
  }, [_vm._v("38")]), _vm._v(" Certainty is impossible, but most commentators agree that a place in Syria (or perhaps even Palestine) is likely.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-4"
    }
  }, [_c('strong', [_vm._v("IV. AUTHORSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The external evidence is unanimous that the author was Matthew, one of the twelve apostles. Thus Irenaeus says, “Matthew also issued a written Gospel among the Hebrews in their own dialect, while Peter and Paul were preaching at Rome, and laying the foundations of the Church” ("), _c('em', [_vm._v("Adv. Haer.")]), _vm._v(" 3.1.1). According to Eusebius, Origen held that Matthew was the first of the Gospels to be written and that it was written in Hebrew ("), _c('em', [_vm._v("Eccl. Hist.")]), _vm._v(" 6.25.4), and Eusebius himself held that Matthew, having first preached to Hebrews, wrote his Gospel for them “in his native language” when he was on the point of leaving them ("), _c('em', [_vm._v("Eccl. Hist.")]), _vm._v(" 3.24.6). Eusebius also refers to the writings of Papias, bishop of Hierapolis c. 60-130 (so "), _c('em', [_vm._v("ODCC),")]), _vm._v(" and says that according to Papias: “Matthew collected the oracles in the Hebrew language, and each interpreted them as best he could” ("), _c('em', [_vm._v("Eccl. Hist.")]), _vm._v(" 3.39.16)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "ft39"
    }
  }, [_vm._v("39")])]), _vm._v(" Eusebius denies that Papias was a hearer of the apostles, but the passage he quotes from Papias to show this says that that worthy proposed to set down “all that I ever learnt well from the presbyters.” He goes on to speak of “the words of the presbyters, what Andrew or Peter or Philip or Thomas or James or John or Matthew, or any other of the Lord’s disciples, had said,” and further, “what Aristion and the presbyter John, the Lord’s disciples, were saying” ("), _c('em', [_vm._v("Eccl. Hist.")]), _vm._v(" 3.39.3-4). Papias is claiming that he had information from people who had heard a number of the apostles, and he speaks of two disciples as still speaking. Papias is thus an early witness. Irenaeus says that he was a hearer of John and a companion of Polycarp ("), _c('em', [_vm._v("Adv. Haer.")]), _vm._v(" 5.33.4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "ft40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Gundry devotes a good deal of attention to the statements of Papias, which he dates before A.D. 110 and which he understands to mean that “John the elder and apostle ascribes the first gospel to the Apostle Matthew.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "ft41"
    }
  }, [_vm._v("41")]), _vm._v(" Gundry denies that we should understand Papias to be saying that Matthew wrote in Hebrew; rather, in describing Matthew, “‘a Hebrew dialect’ means a Hebrew way of presenting Jesus’ messiahship.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "ft42"
    }
  }, [_vm._v("42")])]), _vm._v(" Not everyone will be convinced by Gundry’s argument, but at least he makes it clear that Papias does not rule out Matthean authorship of our first Gospel as decisively as some critics hold. Rather, he should be understood as strengthening the evidence for Matthew as the author.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A puzzle is posed, on the one hand, by the fact that there is widespread agreement in antiquity that Matthew was an early Semitic writing and, on the other, by the fact that the Gospel we have must be regarded as originally written in Greek, not as a translation. This may be why some scholars hold that our Greek Matthew is not a translation of a Hebrew or Aramaic original but a new recension of it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "ft43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is widely agreed by critical orthodoxy that this Gospel was not written by Matthew or for that matter by any close personal follower of Jesus. It is pointed out that the writer makes use of earlier written documents, such as Mark and Q (the symbol to denote a source containing the matter common to Matthew and Luke but not in Mark). M is also included to denote the matter peculiar to this Gospel, which is also understood as coming from a written source. Attention is also drawn to the omission of words and phrases that seem to belittle Jesus or to emphasize the limitations of the Twelve. These are important considerations and must be given due weight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There remains the fact that in ancient tradition this book is universally ascribed to Matthew. To name anyone else as the author is to affirm that the name of its true author was forgotten within a comparatively short time (about 50 years?) and another name substituted, especially since Matthew was not, as far as our information goes, especially prominent either among the Twelve or in the early church. Accordingly, there seems to be no reason for assigning to him such an important writing unless in fact he wrote it. But against Matthean authorship it is pointed out that just as ancient tradition is unanimous in saying that Matthew was the author, so is it unanimous in saying that he wrote it in Hebrew. Now this Gospel is written in good idiomatic Greek, and there is no indication that it was translated from a Semitic original."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "ft44"
    }
  }, [_vm._v("44")])]), _vm._v(" If the tradition was wrong about the "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("book’s being a translation, it is argued, it could also be wrong about its author. It could, of course, but the one does not necessarily imply the other. Perhaps Matthew wrote a Gospel in Aramaic that later was lost. Or perhaps one of the sources that lie behind this Gospel was in Aramaic.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("It is routinely pointed out that none of the ancient MSS of this Gospel says that Matthew was the author. This argument should be looked at more closely than it usually is, despite the fact that it is almost universally accepted by modern scholarship. It takes no note of the fact that, whether in ancient or modern times, few books give any indication of authorship beyond the title page (other than autobiographies or books in which the author plays a prominent part). The title page indicates the author quite clearly, and there is no reason for repeating the information anywhere else in the book. Now none of the oldest MSS of this Gospel has been preserved with the title page intact, but from the earliest ones that do have it onward the book is invariably ascribed to Matthew. This point is of greater weight than is usually recognized. We must face the fact that throughout antiquity it is accepted that Matthew wrote this Gospel and that there is no other name in the tradition."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "ft45"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This argument is sometimes supported by the fact that Matthew was a tax collector"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "ft46"
    }
  }, [_vm._v("46")])]), _vm._v(" and therefore would necessarily have had literary skills. He would certainly have had some experience in writing and would have known Greek, but we can scarcely go beyond that, as far as his occupation is concerned."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "ft47"
    }
  }, [_vm._v("47")])]), _vm._v(" An objection to Matthew as the author is that an apostle would not have used the work of one who did not belong to the apostolic "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("band, namely Mark. To that two things could be said. One is that while it is likely that this Evangelist used Mark’s Gospel, we must bear in mind that this has never been proved beyond any doubt and that some great names are ranged against the view. The other is that no reason appears to be adduced to rule out an apostle’s using the work of a nonapostle."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "ft48"
    }
  }, [_vm._v("48")]), _vm._v(" Why should this not happen? In an age when authors seem to have copied from one another far more than they do today there seems to be no objection to the view, provided that Matthew thought the source reliable. And he would be especially ready to use it if he was aware of the tradition that Peter was associated with Mark in the writing of his book."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "ft49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the last resort it appears that the authorship of this Gospel will remain in dispute. In my opinion there is more to be said for the apostle Matthew than recent scholarship commonly allows and more for Matthew than for any other candidate. But the evidence certainly falls short of complete proof, and in the end divergent views will continue to be held."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "ft50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-5"
    }
  }, [_c('strong', [_vm._v("V. SOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most of the content of Mark is also found in this Gospel, though generally in a shorter form."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "ft51"
    }
  }, [_vm._v("51")])]), _vm._v(" Most scholars have concluded that our author was apparently glad to use the earlier Gospel, but did not appreciate the length at which Mark wrote his stories. It is also clear that he shared with Luke a source with a good deal of information that we do not find in Mark."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "ft52"
    }
  }, [_vm._v("52")])]), _vm._v(" There is a problem in the fact that sometimes Matthew and Luke agree against Mark, and when they differ from one another sometimes one and sometimes the other agrees with Mark. In my opinion critics generally have paid too little attention to Luke’s express statement that “many” have taken it on themselves to write on this subject (Luke 1:1). While not everybody could read and write in the first century, many people could, and the "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Pauline correspondence, for example, is evidence that Paul knew that in every congregation there were people who could read what he wrote. It is in the highest degree likely that others than our four Evangelists and the authors of such sources as Q wrote about the life and teaching of Jesus. But since their writings have perished we have no way of knowing what was in them. We should not presume that everything that has come down to us was originally in Mark, Q, M (Matthew’s special source), and L (Luke’s special source). There must have been many other writings about Jesus, and we have no way of knowing whether Matthew used any of them or not.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Critical orthodoxy works on the “Two Document” theory, the view that Matthew and Luke had before them two documents, Mark and Q."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "ft53"
    }
  }, [_vm._v("53")]), _vm._v(" Sometimes this is expressed as a “Four Document” theory, adding M (the source of what Matthew alone has) and L (what Luke alone has). A good deal can be accounted for on this basis, but there are some difficulties, such as the agreements of Matthew and Luke against Mark. How could this happen if there were no more than four sources and the final two Evangelists followed their sources reasonably closely? Such problems have caused some scholars to rethink the process, and in recent years there has been a revival of the hypothesis of J. J. Griesbach. This view dispenses with Q and takes Matthew to be the first Gospel to have been written, followed by Luke and then Mark."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "ft54"
    }
  }, [_vm._v("54")])]), _vm._v(" On this view Mark was produced by reworking some of the material in the two longer Gospels. Perhaps there was some rivalry between supporters of Matthew and Luke, and this Gospel was produced to take up a mediating position."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "ft55"
    }
  }, [_vm._v("55")])]), _vm._v(" More can be accounted for on this hypothesis than a good number of critics have conceded, but it still remains unsatisfactory."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "ft56"
    }
  }, [_vm._v("56")])]), _vm._v(" It is not easy to understand why Mark in abbreviating Matthew should so consistently come up with narratives that are longer as well as more lifelike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It appears that many writers are all too ready to ignore Luke’s express statement (to which we have already referred) that “many” had written before him. In the first century literacy was reasonably widespread, and the New Testament gives ample evidence that writing was congenial to the early Christians. Why should we limit the accounts of Jesus’ teaching "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("to the four Gospels plus three hypothetical sources? It seems much more likely that many did write about Jesus but that in time most of their works perished. When the four Gospels were produced they evidently were so superior to the other writings about Jesus in circulation that in time they drove the rest out of business. Why go to all the trouble of copying a source when you could have it incorporated with other material in a satisfying Gospel? It seems to me not only that have we not solved the Synoptic Problem, but also that we are not likely ever to solve it. Too much of the writing of the early church has perished."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "ft57"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is suggested that Matthew’s infancy narratives give evidence of a Hebrew source. Thus there is a play on the words “Jesus” and “Savior” in 1:21,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn58",
      "id": "ft58"
    }
  }, [_vm._v("58")])]), _vm._v(" which is natural in Hebrew but impossible in Aramaic. This suggestion may be supported by some of the quotations from the Old Testament. Many come from LXX, but there is a group of quotations introduced by “that it might be fulfilled which was spoken through the prophet” or similar words (1:22-23; 2:5-6, etc.). Except for 3:3 all are found in Matthew only. These are not as close to LXX as other quotations in this Gospel and may be independent translations from the Hebrew. Some differ from our Hebrew text (as 1:23; 2:6; 4:15; 13:35). Such considerations may point us to a source or sources. But we can scarcely say more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I cannot leave this section on sources without drawing attention to a point made so well by Patte: “Some may be surprised that I do not pay more attention to Matthew’s sources and to the way in which he modifies them. I simply take seriously the fact that when an author duplicates a source and makes it part of his or her own discourse, he or she has appropriated that source. In other words, even when Matthew duplicates exactly what one of his sources says, the passage has to be viewed as expressing "), _c('em', [_vm._v("Matthew’s")]), _vm._v(" convictions and views.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn59",
      "id": "ft59"
    }
  }, [_vm._v("59")])]), _vm._v(" Many commentaries spend a good deal of time on what Matthew has done to his sources. While I concede that much can be learned from such exercises, I agree with Patte that when Matthew incorporates a source it is because he has made it his own and wants to express what that source is saying. It is more important to understand what the words mean in their new situation than to engage in scholarly niceties about how they came to be there."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn60",
      "id": "ft60"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(". Zahn, cited in Lenski, p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Mounce remarks, “Matthew is the Gospel that over the years has shaped the life and thought of the church”; he cites Renan’s view that it is the most important book ever written (p. xiii).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('em', [_vm._v("Les Évangiles")]), _vm._v(" (Paris, 1877), p. 283.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Graham Stanton points to the recent spate of books and articles on Matthew and sees debate now as “keener than ever. So many of the distinctive features of this Gospel continue to fascinate and to puzzle scholars that it is no exaggeration to suggest that Matthew is a new storm centre in contemporary scholarship” (Stanton, p. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Not only in ancient times. Johnson points out that “in the 1929 revision of the American Book of Common Prayer Matthew is favored over Luke with thirty-seven to thirty-three pericopes, John being used twenty-seven times and Mark six times.” He goes on to say that the layman may claim that John or Luke is his favorite but he will probably “make actual use more often of Matthew” (p. 231).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("Matthew: Evangelist and Teacher")]), _vm._v(" (Exeter, 1989), p. 20. He cites E. Massaux, “Matthew seems to have been the only one to have had a normative role, and to have created the climate of Christianity at large” (p. 16).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Curiously F. W. Beare calls this Gospel “a grim book,” “singularly lacking in those notes of joy that sound through the writings of Luke. The Christ that he presents is on the whole a terrifying figure. … There is little trace here of a gospel of grace abounding to the chief of sinners” (p. viii). He speaks of Matthew as paving the way for “a new legalism” (p. 6). Has he not noticed the note of joy at the beginning and end of the Gospel (2:10; 28:8) and, of course, in between as well (e.g., 5:12; 13:44, etc.)? And what sort of legalism is it of which even Beare can say, “Wealth cannot purchase an entrance (i.e. into the kingdom). … It is not a reward for virtue or for any kind of human achievement” (p. 36)? There can be no greater emphasis on the significance of love, love to God and love to people, than we find in Matthew 22:37-40. Such a misunderstanding of Matthew as Beare’s is not helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(". In this Gospel “we see, as we could see nowhere else, how believers of the same race as Jesus, brought up in the same religious tradition, with the same spiritual ancestry, looked upon the Christ” (Robinson, pp. x-xi).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(". S. van Tilborg puts great emphasis on Matthew’s criticisms of Judaism, so much so that he views the author as a Gentile (The "), _c('em', [_vm._v("Jewish Leaders in Matthew")]), _vm._v(" [Leiden, 1972], p. 171).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(". "), _c('em', [_vm._v("AB,")]), _vm._v(" p. XXII. They also say, “Matthew seems to have been influenced most by the theological idea of fulfillment” (p. XXVI).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(". That is, most in the Gospels; Paul is the big user of the term, employing it 379 times.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Johnson, p. 234.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(". G. D. Kilpatrick, "), _c('em', [_vm._v("The Origins of the Gospel according to St. Matthew")]), _vm._v(" (Oxford, 1946), p. 70. This may be a simplistic view of what Matthew has done.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" pp. 77, 141.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(". I have examined this problem in "), _c('em', [_vm._v("The New Testament and the Jewish Lectionaries")]), _vm._v(" (London, 1964). We should not forget that the account in Luke 4 is the oldest one we have of a synagogue service, nor that it is still not clear when either of the two principal lectionary systems, the one-year cycle and the three-year cycle, made its appearance. It is hazardous to argue from Jewish practice when we know so little about it.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(". K. Stendahl, p. 769.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(". G. Bornkamm heads his discussion of this Gospel “The Teacher of the Church (Matthew)” and finds a “didactic concern” that “stamps the whole Gospel” ("), _c('em', [_vm._v("The New Testament: A Guide to its Writings")]), _vm._v(" [London, 1974], pp. 57, 60).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Johnson can say, “His prose differs from that of Plato to approximately the extent that the English in the news columns of a well-written metropolitan daily differs from that of Shakespeare and the King James Version. The Greek of the Gospel is fluent and clear, easily read by simple people but generally without offensive colloquialisms” (p. 239).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Filson, p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(". E. von Dobschütz says that Matthew “likes echoes”; he points to this apostle’s penchant for using formulas repeatedly and for saying the same thing twice (Stanton, p. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('em', [_vm._v("Matthew: Evangelist and Teacher,")]), _vm._v(" p. 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(". This view was accepted, for example, by R. H. Fuller, who could write, “The clue to Mt’s theology is the five discourses. These correspond with the 5 books of the Pentateuch. Jesus is the second Moses, the founder and lawgiver of the new Israel, the church” (A "), _c('em', [_vm._v("Critical Introduction to the New Testament")]), _vm._v(" [London, 1966], p. 117). But in this Gospel Jesus is not the second Moses; as W. D. Davies puts it, “He is not Moses come as Messiah, if we may so put it, so much as Messiah, Son of Man, Emmanuel, who has absorbed the Mosaic function” ("), _c('em', [_vm._v("Sermon,")]), _vm._v(" p. 27).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(". "), _c('em', [_vm._v("SM,")]), _vm._v(" p. 107. There are problems in detail, such as the difficulty of finding anything corresponding to Leviticus in Matthew’s arrangement.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Filson, pp. 22-23. Davies questions “the extreme scepticism” about our knowledge of the life and teaching of Jesus. “First, the milieu within which Jesus appeared was conditioned for the faithful reception and transmission of tradition” (he draws attention to the oral transmission of matter now in the Mishnah). “Secondly, the technical formulae describing the reception and transmission of tradition emerge so clearly in the NT documents that we must believe that the early Christian communities handed on a tradition.” Thirdly, Jesus may have been bilingual and certainly many early Christians were, so that teaching could be transferred to Greek accurately. “Fourthly, it is highly pertinent to note that there was frequent intercourse between figures such as Peter, and other apostolic guardians of the tradition, and Christian communities in various places, so that the transmission and development of the tradition were not unchecked” ("), _c('em', [_vm._v("Sermon,")]), _vm._v(" pp. 127-28; cf. also "), _c('em', [_vm._v("SM,")]), _vm._v(" pp. 416-17).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v(". F. L. Cross, ed., "), _c('em', [_vm._v("Studia Evangelica,")]), _vm._v(" IV (Berlin, 1968), pp. 48-49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('em', [_vm._v("Structure,")]), _vm._v(" p. 10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('em', [_vm._v("Matthew: Evangelist and Teacher,")]), _vm._v(" p. 83. Irenaeus says that this Gospel was written while Peter and Paul were preaching in Rome ("), _c('em', [_vm._v("Adv. Haer.")]), _vm._v(" 3.1.1). We are not aware of these two apostles preaching in Rome together, but clearly Irenaeus thinks of this Gospel as written in the 60s.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(". Gundry, p. 601, points out that we have less evidence for the dating of Mark than we have for that of Matthew, so that we should date Mark from Matthew, not the reverse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(". That these words were written after the destruction of the city is not at all obvious, despite the arguments of scholars who accept this point of view. J. A. T. Robinson is not persuaded, and he cites K. H. Rengstorf and Sigfried Pedersen as others who do not accept it ("), _c('em', [_vm._v("Redating,")]), _vm._v(" p. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(". He points out that the Romans apparently did not try to burn the temple and makes this the responsibility of the Jews: “The flames, however, owed their origin and cause to God’s own people” (War 6.251); the defenders themselves kindled the flames, at least in part. The Romans then set the surrounding buildings alight (War 6.281). But it was at a later time that the city as a whole was captured and Titus entered it (War 6.409), and later still that “the whole city” and what was left of the temple were “razed to the ground” ("), _c('em', [_vm._v("War")]), _vm._v(" 7.1).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(". C. C. Torrey long ago argued that “all four Gospels were written before the year 70”; he pointed out that “The supposed references” to the overthrow of Jerusalem by the Romans “are in every word and without exception merely repeated from Old Testament prophecies.” He proceeds to cite the relevant prophecies (The "), _c('em', [_vm._v("Four Gospels")]), _vm._v(" [London, n.d.], p. 256). More recently J. A. T. Robinson has also argued that the Gospels must have been written before A.D. 70 ("), _c('em', [_vm._v("Redating,")]), _vm._v(" ch. 2).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("Use of the OT,")]), _vm._v(" pp. 178-79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('em', [_vm._v("Redating,")]), _vm._v(" p. 116; cf. pp. 99, 107.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(". B. Reicke can say, “The situation presupposed by Matthew corresponds to what is known about Christianity in Palestine between A.D. 50 and ca. 64, but not after the flight of the Christians in ca. 64 and the start of the Jewish war in A.D. 66” (D. E. Aune, ed., "), _c('em', [_vm._v("Studies in New Testament and Early Christian Literature")]), _vm._v(" [Leiden, 1972], p. 133).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(". B. H. Streeter argued strongly for Antioch as the place of origin ("), _c('em', [_vm._v("The Four Gospels")]), _vm._v(" [London, 1930], pp. 500-527).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(". "), _c('em', [_vm._v("Origins,")]), _vm._v(" ch. VII; the conclusion is reached on p. 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(". The case for Caesarea was persuasively argued by B. T. Viviano ("), _c('em', [_vm._v("CBQ,")]), _vm._v(" 41 [1979], pp. 533-46).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(". van Tilborg argues this ("), _c('em', [_vm._v("The Jewish Leaders,")]), _vm._v(" p. 172).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(". Unfortunately Papias’s work is no longer extant; therefore we must depend on the quotations made in Eusebius. Allen thinks that Papias’s work may well have been “a book containing sayings, discourses, and parables.” He points out that about two-fifths of Matthew consists of sayings and suggests that someone took the sayings from Papias and worked them into a larger book, our Gospel. It then came to be named from the author of the sayings book that had been incorporated in it (pp. lxxx-lxxxi). Barclay has much the same view (I, p. xxi). T. W. Manson ("), _c('em', [_vm._v("Sayings,")]), _vm._v(" pp. 27-30) and others argue that Papias is referring to the document we call Q. Robinson holds that “‘logia’ means the Old Testament,” so that Papias may have been referring to a “collection of ‘oracles’ dealing with the Messiah, such as might be used by the Christian to prove to the Jew that Jesus was the Christ. We know that such collections were current in the third century, and that they passed in the western church under the name of ‘Testimonies,’ but in the Jewish church the need for them would be immediate and urgent” (p. xv).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(". C. S. Petrie argues strongly that Papias must be taken seriously and that he testifies to Matthew as the author of the Gospel composed in the Hebrew language ("), _c('em', [_vm._v("NTS,")]), _vm._v(" XIV [1967-68], pp. 15-32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v(". Gundry, p. 620.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" pp. 619-20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v(". See Hendriksen, p. 91. C. F. D. Moule suggests that “the oracles” point us to some “early Semitic source lying behind both Matt. and Lk.” and thinks that Papias’s reference to each translating them as best he could may explain some of the differences between Matthew and Luke ("), _c('em', [_vm._v("The Birth of the New Testament")]), _vm._v(" [London, 1962], p. 89).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v(". A. Wikenhauser remarks, “It may be taken as certain that an Aramaic original of the Gospel of St. Matthew can be defended only if we regard Greek Mt. not as a literal translation of the Aramaic, but as a thorough revision made with frequent use of the Gospel of St. Mark.” He adds that this “is consistent with the decision of the Biblical Commission” ("), _c('em', [_vm._v("New Testament Introduction")]), _vm._v(" [New York, 1958], p. 195).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(". Fenton remarks, “It is possible that this Gospel was from the first published with the title "), _c('em', [_vm._v("According to Matthew”")]), _vm._v(" (p. 136).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(". Matthew is said to be a tax collector in 9:9; 10:3 and a member of the Twelve in 10:3; Mark 3:18; Luke 6:15. The tax collector is called Levi in Mark 2:14; Luke 5:27, but, although it is unusual for the same man to have two Hebrew names (though he might have a Hebrew and a Greek name, like Saul who was called Paul), it seems that all these references are to the same man. That the author of this Gospel was a tax collector is perhaps supported by his interest in money. He uses the general word for money, "), _c('em', [_vm._v("nomisma,")]), _vm._v(" and the words for “gold” 5 times, “silver” 10 times (two words), and “talent” 14 times, a total of 29, whereas Mark refers to “silver” once and Luke has it 4 times; they have none of the other words for big currency. Matthew also has references to coins such as the "), _c('em', [_vm._v("assarion,")]), _vm._v(" the "), _c('em', [_vm._v("chalkos,")]), _vm._v(" the "), _c('em', [_vm._v("denarius,")]), _vm._v(" the "), _c('em', [_vm._v("didrachma,")]), _vm._v(" the "), _c('em', [_vm._v("kodrantes,")]), _vm._v(" and the "), _c('em', [_vm._v("stater.")]), _vm._v(" Mark and Luke mention some of these coins, but not as many as Matthew.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(". C. F. D. Moule remarks, “Is it not conceivable that the Lord really did say to that tax-collector Matthew: You have been a ‘writer’ (as the Navy would put it); you have had plenty to do with the commercial side of just the topics alluded to in the parables — farmer’s stock, fields, treasure-trove, fishing revenues; now that you have become a disciple, you can bring all this out again — but with a difference?” (F. L. Cross, ed., "), _c('em', [_vm._v("Studia Evangelica,")]), _vm._v(" II [Berlin, 1964], p. 98). Gundry argues that Matthew “was a notetaker during the earthly ministry of Jesus and that his notes provided the basis for the bulk of the apostolic gospel tradition,” citing the practice in “ancient schools” by which notes taken by students “became the common possession of the schools and circulated without the name of the author” (Use "), _c('em', [_vm._v("of the OT,")]), _vm._v(" p. 182).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft48",
      "id": "fn48"
    }
  }, [_vm._v("48")]), _vm._v(". Cf. R. M. Grant, “This claim does not seem very convincing. We cannot tell whether or not an apostle would have followed such a procedure. An apostle might have believed that Mark’s outline was largely correct but needed some revision and some supplementation” (A "), _c('em', [_vm._v("Historical Introduction to the New Testament")]), _vm._v(" [London, 1963], p. 129).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v(". N. B. Stonehouse argues strongly for Matthean authorship in "), _c('em', [_vm._v("Origins of the Synoptic Gospels")]), _vm._v(" (London, 1964), pp. 1-47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft50",
      "id": "fn50"
    }
  }, [_vm._v("50")]), _vm._v(". A. F. J. Klijn finds many questions about the authorship of this Gospel undecided, but does not consider this very important, “For none of the other gospels bear less the personal imprint of their authors than does this one” ("), _c('em', [_vm._v("An Introduction to the New Testament")]), _vm._v(" [Leiden, 1967], p. 34).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(". I have discussed the Synoptic problem, the way the three Synoptic Gospels relate to one another, in "), _c('em', [_vm._v("Luke: An Introduction and Commentary"), _c('sup', [_vm._v("2")])]), _vm._v(" (Leicester and Grand Rapids, 1988), pp. 51-63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(". An exception is M. D. Goulder, who holds that Matthew was composed as a lectionary. He agrees that the author had Mark before him but “no Q, no M, and very little oral tradition” ("), _c('em', [_vm._v("Midrash and Lection in Matthew")]), _vm._v(" [London, 1974], p. xiii). His suggestion has attracted a good deal of attention but seems to me to be inadequately based. I have discussed his work with other lectionary hypotheses in “The Gospels and the Jewish Lectionaries,” in R. T. France and David Wenham, eds., "), _c('em', [_vm._v("Gospel Perspectives,")]), _vm._v(" III (Sheffield, 1983), pp. 129-56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(". Many scholars have been too confident about Q, and there have been criticisms. O. Linton, to name but one, has subjected the hypothesis that there was such a source to critical examination. He agrees that there was such a source, but it does not account for anything like all the non-Markan matter that is common to Matthew and Luke (D. E. Aune, ed., "), _c('em', [_vm._v("Studies in the New Testament and Early Christian Literature,")]), _vm._v(" pp. 43-59).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v(". Hamann thinks that the order was Matthew, Mark, and Luke (p. 306).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft55",
      "id": "fn55"
    }
  }, [_vm._v("55")]), _vm._v(". There are, of course, still other theories. F. Neirynck, for example, has given close attention to the theory of A. Gaboury which puts heavy emphasis on the order of the pericopes: “One guiding principle pervades the whole study of the phenomenon of order: the evangelists never altered the order of incidents they found in their sources. This principle is extremely simple indeed, but it forces the author to an unnecessary multiplication of sources” ("), _c('em', [_vm._v("L’ÉSM,")]), _vm._v(" pp. 37-69; the quotation is from p. 68). Such theories are unsatisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft56",
      "id": "fn56"
    }
  }, [_vm._v("56")]), _vm._v(". For example, there is B. H. Streeter’s objection to the view that Mark has abbreviated Matthew: “only a lunatic would leave out Matthew’s account of the Infancy, the Sermon on the Mount, and practically all the parables, in order to get room for purely verbal expansion of what was retained” (The "), _c('em', [_vm._v("Four Gospels")]), _vm._v(" [London, 1930], p. 158).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v(". Albright and Mann further draw attention to the vitality of oral tradition and open the possibility that “Mark and Matthew may represent two quite separate collections of tradition” ("), _c('em', [_vm._v("AB,")]), _vm._v(" p. XLVIII). We should not let our familiarity with a multiplicity of printed books hide from us the importance of oral tradition in a day when all books had to be laboriously written by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft58",
      "id": "fn58"
    }
  }, [_vm._v("58")]), _vm._v(". “Jesus” is "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("יֵשֻׁעַ")]), _vm._v(" and “will save” is "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("יוֹשִׁיעַ")]), _vm._v("; “since such a play is not possible in Aramaic, a Hebrew original must underlie the verse” (McNeile).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft59",
      "id": "fn59"
    }
  }, [_vm._v("59")]), _vm._v(". Patte, p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft60",
      "id": "fn60"
    }
  }, [_vm._v("60")]), _vm._v(". Cf. Brevard S. Childs, “the assumption that the many tensions within the Gospel are to be resolved by sharply distinguishing between tradition and redaction (cf. Strecker, Schulz) renders impossible a canonical reading of the Gospel as a whole. Thus the judgment that portions of ch. 5 are ‘traditional ballast’ which distort Matthew’s real intention, is a highly tendentious approach” (The "), _c('em', [_vm._v("New Testament as Canon: An Introduction")]), _vm._v(" [London, 1984], p. 62).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d85d198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Introduction.vue
// module id = 75
// module chunks = 0